(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["filters"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    try {
      document.addEventListener('DOMContentLoaded', function () {
        var wrapper = document.querySelector('.facets__filters-wrapper');
        if (!wrapper) return;

        var detailsList = wrapper.querySelectorAll('details');
        if (!detailsList.length) return;

        detailsList.forEach(function (details) {
          details.addEventListener('toggle', function () {
            if (!details.open) return;

            detailsList.forEach(function (other) {
              if (other !== details && other.open) {
                other.open = false;
              }
            });
          });
        });
      });
    } catch (e) {
      // Fail silently – kisi aur JS ko effect nahi karega
      console.warn('Accordion safe-script error:', e);
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
